module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921062649_T.adb815c8.jpg";